module.exports = __webpack_public_path__ + "static/media/img_32.3b4628cf.png";